import { addStyles } from 'ethcss'
import { IStyles, colors, mediaCSS } from 'theme'

export const tabListStyles: IStyles = {
    list: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: 28,
        minHeight: 34,
        overflowX: 'auto',
        borderBottom: `1px solid ${colors.greyLight}`,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        [mediaCSS.mob]: {
            gap: 20,
        },
    },
}

addStyles(tabListStyles)
